import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import ls from "util/secureStorage";
import constant from "config/constant";
import { wrapBaseApi } from "util/apiWrapper";

// console.log("AUTH HEADER", _headers);

// Define a service using a base URL and expected endpoints
export const rateApi = createApi({
  reducerPath: "exchangeRate",
  // refetchOnReconnect: true,
  refetchOnMountOrArgChange: true,
  tagTypes: ["rate"],
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_WALLET_API_ENDPOINT}`,
    prepareHeaders: (headers, _) => {
      const auth = ls.get(constant.AUTH_TOKEN_KEY);

      headers.set("Authorization", auth.token);
      headers.set("Content-Type", "application/json");
      headers.set("Cache-Control", "no-cache, no-store, must-revalidate");
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getRate: builder.query({
      query: (ticker) => wrapBaseApi(`/wallet/rate/exchangeRate?ticker=${ticker}`),
      transformResponse: (res) => res?.data,
      // providesTags: ["rate"],
    }),
    getCoinToUsdRate: builder.query({
      query: (coin) => wrapBaseApi(`/wallet/rate/exchangeRate?ticker=${coin}usd`),
      transformResponse: (res) => res?.data,
      // providesTags: ["rate"],
    }),
    getPriceAlerts: builder.query({
      query: () => wrapBaseApi(`/wallet/price-alert`),
      transformResponse: (res) => res?.data,
      // providesTags: ["rate"],
    }),
    getPriceAlertById: builder.query({
      query: (id) => wrapBaseApi(`/wallet/price-alert/${id}`),
      transformResponse: (res) => res?.data,
      // providesTags: ["rate"],
    }),
    createPriceAlert: builder.mutation({
      query: (input) => ({
        url: wrapBaseApi(`/wallet/price-alert`),
        method: "POST",
        body: input,
      }),
      transformResponse: (res) => res?.data,
    }),
    updatePriceAlert: builder.mutation({
      query: ({ id, ...input }) => ({
        url: wrapBaseApi(`/wallet/price-alert/${id}`),
        method: "PUT",
        body: input,
      }),
      transformResponse: (res) => res?.data,
    }),
    deletePriceAlert: builder.mutation({
      query: (id) => ({
        url: wrapBaseApi(`/wallet/price-alert/${id}`),
        method: "DELETE",
        // body: input,
      }),
      transformResponse: (res) => res?.data,
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetRateQuery,
  useGetCoinToUsdRateQuery,
  useGetPriceAlertsQuery,
  useGetPriceAlertByIdQuery,
  useCreatePriceAlertMutation,
  useUpdatePriceAlertMutation,
  useDeletePriceAlertMutation,
  endpoints,
} = rateApi;

export default rateApi;
